import Navigator from './app/navigation/router'
import './App.css'
import { persistor, store } from '../src/app/redux/store/store'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider,  } from 'react-redux'
import { useEffect,  } from 'react'
import RestrictedAccessPage from './app/components/restricted/RestrictedPage'
import useDeviceType from './app/utility/useDeviceType'
import PageAlert from './app/components/PageAlert'
import { MotionConfig } from 'motion/react'

function App() {
  let deviceType = useDeviceType()

  useEffect(() => {
    const clearPageOnUrlChange = () => {
      localStorage.removeItem('currentPage')
      localStorage.removeItem('leavePagination')
    }
    window.addEventListener('beforeunload', clearPageOnUrlChange)
    return () => {
      window.removeEventListener('beforeunload', clearPageOnUrlChange)
    }
  }, [])

  useEffect(() => {
    if (deviceType === 'Mobile') {
      localStorage.clear()
      sessionStorage.clear()
    }
  }, [deviceType])

  if (deviceType === 'Mobile') {
    return <RestrictedAccessPage />
  }

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          {/* every `motion` animation honours prefers-reduced-motion */}
          <MotionConfig reducedMotion="user">
            {/* Alert host lives here, not in the shell: Login is a sibling
                route of the shell, so a PageAlert mounted inside Sidebar never
                exists on /login and every Utils.toast there was thrown away. */}
            <PageAlert />
            <Navigator />
          </MotionConfig>
        </PersistGate>
      </Provider>
    </>
  )
}

export default App
